export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const OAUTH_BASE_URL = import.meta.env.VITE_OAUTH_BASE_URL;
export const REALM_NAME = import.meta.env.VITE_REALM_NAME;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
// export const NOTIFICATION_URL = import.meta.env.VITE_NOTIFICATION_URL;
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
export const ENV_PREFIX = import.meta.env.VITE_ENV_PREFIX;
export const NODE_ENV = import.meta.env.MODE;
export const BUILD_NUMBER = import.meta.env.VITE_BITBUCKET_BUILD_NUMBER;
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE;
export const BUILD_VERSION = `1health FrontEnd Build-${import.meta.env.VITE_BITBUCKET_BUILD_NUMBER} ${import.meta.env.VITE_BITBUCKET_COMMIT}`;
export const SENTRY_DSN_KEY = import.meta.env.VITE_SENTRY_DSN_KEY;
export const SENTRY_SAMPLE_RATE = import.meta.env.VITE_SENTRY_SAMPLE_RATE;
export const GOOGLE_MEASUREMENT_ID = import.meta.env.VITE_GOOGLE_MEASUREMENT_ID;

export const AM_CHARTS_5_LICENSE_KEY = import.meta.env.VITE_AM_CHARTS_5_LICENSE_KEY;
// NG-7512: reCaptcha kill switch. Enabled by default; set VITE_FEATURE_RECAPTCHA="false" to turn
// reCaptcha off on demand (e.g. during a prolonged Google outage) without a code change.
export const FEATURE_RECAPTCHA = import.meta.env.VITE_FEATURE_RECAPTCHA !== "false";

// NG-8648: base URL of the environment this deployment provisions alongside itself during developer
// registration (the "downstream" of NG-8654's trust relationship). Pairings are configuration, not
// derived from the hostname: prod → demo, demo → QA, dev → QA, QA → dev. This is a graph rather than a
// chain — QA is the downstream of both demo and dev, and dev and QA point at each other — which is
// safe because provisioning is exactly one hop and never chains onwards.
// Unset means single-environment registration. Every deployed environment sets it, so that is the
// local dev and test default rather than a real deployment state.
export const SANDBOX_API_BASE_URL = import.meta.env.VITE_SANDBOX_API_BASE_URL;
// The topology cannot be discovered at runtime — NG-8654 is explicit that asking an environment that
// issues no assertion is a 400, not a silent no-op — so the presence of the URL IS the switch for
// both the cross-environment provisioning and the `requestAssertion` flag on OTP verify.
export const FEATURE_DUAL_ENV_DEVELOPER_SIGNUP = !!SANDBOX_API_BASE_URL;

export const LOCAL_STORAGE_ITEM_LOCALE = "Locale";
export const LOCAL_STORAGE_ITEM_LANG = "Language";
export const APP_DEFAULT_LANGUAGE = "en";
export const DEFAULT_TENANT_ID = 1;
export const MY_TESTS_CUSTOM_LOGIN_COOKIE_NAME = "my-tests-custom-login";
export const CODE_VERIFIER_LIFE_SECONDS = 300;
export const TENANT_1HEALTH_NAME = "1health";
export const TERMS_URL = "https://www.tachin.ai/terms";
export const PRIVACY_URL = "https://www.tachin.ai/privacy";

export const SESSION_STORAGE_VERSION_KEY = "new-data-loaded";
export const REDIRECT_STATE_STORAGE_KEY = "redirect-state";
